import { toast } from "react-toastify";
import pdsrValidationItemExists from "./PdsrValidationItemExists";

export const isItemValid = (item: any, showNotify = true) => {
  if (!item.ContainerNetwork) {
    if (showNotify) {
      toast.error("Missing field ContainerNetwork");
    }
    return false;
  }
  if (!item.PlantGsdb) {
    if (showNotify) {
      toast.error("Missing field PlantGsdb");
    }
    return false;
  }
  if (!item.InboundDock) {
    if (showNotify) {
      toast.error("Missing field InboundDock");
    }
    return false;
  }
  if (!item.SupplierGsdb) {
    if (showNotify) {
      toast.error("Missing field SupplierGsdb");
    }
    return false;
  }
  if (!item.ContainerType) {
    if (showNotify) {
      toast.error("Missing field ContainerType");
    }
    return false;
  }
  if (!item.FoldedFlag) {
    if (showNotify) {
      toast.error("Missing field FoldedFlag");
    }
    return false;
  }
  if (!item.OutboundDock) {
    if (showNotify) {
      toast.error("Missing field OutboundDock");
    }
    return false;
  }
  return true;
};

export const itemAlreadyExists = async (item: any) => {
  const exists = await pdsrValidationItemExists({
    Id: item.Id,
    ContainerNetwork: item.ContainerNetwork,
    SupplierGsdb: item.SupplierGsdb,
    PlantGsdb: item.PlantGsdb,
    InboundDock: item.InboundDock,
    OutboundDock: item.OutboundDock,
    FoldedFlag: item.FoldedFlag,
    ContainerType: item.ContainerType,
  });
  if (exists) {
    toast.error("Validation item already exists");

    return true;
  }

  return false;
};

export const isItemValidWithoutToast = async (item: any) => {
  return !(
    !item.ContainerNetwork ||
    !item.PlantGsdb ||
    !item.InboundDock ||
    !item.SupplierGsdb ||
    !item.ContainerType ||
    !item.FoldedFlag ||
    !item.OutboundDock
  );
};
